<script setup lang="ts">
import { CalendarCell} from 'reka-ui';
import { computed} from 'vue';
import {DateValue, getLocalTimeZone} from "@internationalized/date";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "@/core/components/ui/tooltip";
import {CalendarCellTrigger} from "@/core/components/ui/calendar";
import {CalendarEvent} from "@/appointment/components/consumer-appointment-timeline/event-calendar/EventCalendar.vue";
import EventCalendarTooltipEventContent
    from "@/appointment/components/consumer-appointment-timeline/event-calendar/EventCalendarTooltipEventContent.vue";

const {events = [], date} = defineProps<{
    date: DateValue
    month: any;
    events: CalendarEvent[];
    maxEventsPerDay?: number;
}>();

const formattedDate = computed(() => {
    return date.toDate(getLocalTimeZone()).toLocaleDateString('fr-FR', {
        weekday: 'long',
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
});
</script>

<template>
  <CalendarCell
    :date="date"
    class="relative h-auto p-0 flex-1"
  >
    <div class="w-full h-full flex flex-col items-center">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <CalendarCellTrigger
              :day="date"
              :month="month.value"
              class="data-[selected]:bg-primary/40 data-[selected]:text-slate-50 data-[selected]:opacity-100 data-[selected]:hover:bg-primary/40 data-[selected]:hover:text-slate-50 data-[selected]:focus:bg-primary/40 data-[selected]:focus:text-slate-50'"
            >
              {{ date.day }}
              <div
                v-if="events?.length"
                class="w-1.5 h-1.5 rounded-full absolute bottom-0.5 bg-primary"
              />
            </CalendarCellTrigger>
          </TooltipTrigger>
          <TooltipContent v-if="events.length" class="bg-white">
            <div class="flex flex-col gap-2">
              <span class="font-semibold">{{ formattedDate }}</span>
              <EventCalendarTooltipEventContent v-for="event in events" :key="event.id" :event="event" />
            </div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  </CalendarCell>
</template>

<style scoped>

</style>
